/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

@Directive({
  selector: '[iriroCustomWhitespace], [customWhitespace]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomWhitespaceValidator,
      multi: true,
    }
  ],
})
export class CustomWhitespaceValidator implements Validator {
  @Input('customWhitespace') fieldName = '';

  validate(control: AbstractControl): ValidationErrors | null {
    const funcProperties = {
      field: this.fieldName,
    };
    return _hasWhitespaceValidation.bind(funcProperties)(control);
  }
}

export const hasWhitespaceValidation = (fieldName = ''): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
  };

  return _hasWhitespaceValidation.bind(funcProperties);
};

function _hasWhitespaceValidation(this: {field: string}, control: AbstractControl):
  ErrorModel | null {
  let errors: ErrorModel | null = null;

  if (control.value !== null && control?.value?.length) {
    if ((control.value as string).indexOf(' ') >= 0) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: 'hasWhitespace' + this.field,
      };
    }
  }

  return errors ? errors : null;
}
